import React, { useState, useEffect } from 'react';

import * as Antd from 'antd';
import * as AntdIcons from '@ant-design/icons';
import * as SYS from '.';

export const GeneralForm = props => {
    const [form] = Antd.Form.useForm();
    const [currentValues, setCurrentValues] = useState({});

    const layout = {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
    };

    const tailLayout = {
        wrapperCol: { span: 20, offset: 4 },
    };

    useEffect(() => {
        setCurrentValues(props.initialValues);
    }, [props.initialValues]);

    return (
        <Antd.Spin
            spinning={props.loading}
            delay={500}
        >
            <Antd.Form
                {...layout}
                form={form}
                initialValues={props.initialValues}
                onFinish={values => {
                    if (props.onSuccess) {
                        props.onSuccess(values);
                    }
                }}
                onValuesChange={(changedValues, allValues) => {
                    // if (changedValues.type) {
                    setCurrentValues(allValues);
                    // }
                }}
            >
                <Antd.Form.Item
                    name="debugMode"
                    label="Debug mode"
                    rules={[{ required: true }]}
                    valuePropName="checked"
                >
                    <Antd.Switch />
                </Antd.Form.Item>
                <Antd.Form.Item
                    name="applicationName"
                    label="Application name"
                    rules={[{ required: true }]}                    
                >
                    <Antd.Input />
                </Antd.Form.Item>
                <Antd.Divider />
                <Antd.Typography.Title
                    level={5}
                >
                    LDAP
                </Antd.Typography.Title>
                <Antd.Form.Item
                    name={['ldap', 'enable']}
                    label="Enable"
                    rules={[{ required: true }]}
                    valuePropName="checked"
                >
                    <Antd.Switch />
                </Antd.Form.Item>
                <Antd.Form.Item
                    name={['ldap', 'server']}
                    label="Server"
                >
                    <Antd.Input
                        disabled={currentValues.ldap && !currentValues.ldap.enable}
                    />
                </Antd.Form.Item>
                <Antd.Form.Item
                    name={['ldap', 'username']}
                    label="Bind username"
                >
                    <Antd.Input
                        disabled={currentValues.ldap && !currentValues.ldap.enable}
                    />
                </Antd.Form.Item>
                <Antd.Form.Item
                    name={['ldap', 'password']}
                    label="Bind password"
                >
                    <Antd.Input
                        disabled={currentValues.ldap && !currentValues.ldap.enable}
                    />
                </Antd.Form.Item>
                <Antd.Form.Item
                    name={['ldap', 'baseDN']}
                    label="Base DN"
                >
                    <Antd.Input
                        disabled={currentValues.ldap && !currentValues.ldap.enable}
                    />
                </Antd.Form.Item>
                <Antd.Form.Item
                    name={['ldap', 'filter']}
                    label="Filter"
                >
                    <Antd.Input
                        disabled={currentValues.ldap && !currentValues.ldap.enable}
                    />
                </Antd.Form.Item>
                <Antd.Divider />
                <Antd.Typography.Title
                    level={5}
                >
                    User additionals
                </Antd.Typography.Title>
                <Antd.Form.Item
                    name={['userAdditional', 'enable']}
                    label="Enable"
                    rules={[{ required: true }]}
                    valuePropName="checked"
                >
                    <Antd.Switch />
                </Antd.Form.Item>
                <Antd.Form.Item
                    name={['userAdditional', 'connector']}
                    label="Connector"
                >
                    <SYS.ConnectorSelect
                        identificator="code"
                        disabled={currentValues.userAdditional && !currentValues.userAdditional.enable}
                    />
                </Antd.Form.Item>
                <Antd.Form.Item
                    name={['userAdditional', 'dataset']}
                    label="Dataset"
                >
                    <SYS.DatasetSelect
                        identificator="code"
                        disabled={currentValues.userAdditional && !currentValues.userAdditional.enable}
                    />
                </Antd.Form.Item>
                <Antd.Divider />
                <Antd.Form.Item
                    {...tailLayout}
                    style={{
                        marginTop: 10
                    }}
                >
                    <Antd.Button
                        type="primary"
                        htmlType="submit"
                    >
                        Save
                    </Antd.Button>
                </Antd.Form.Item>
            </Antd.Form>
        </Antd.Spin>
    );
}